import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-475bd049")
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Crop Image", -1)
const _hoisted_3 = { id: "modal-canvas-container" }
const _hoisted_4 = { ref: "canvasRef" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { id: "info" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Drag the handles to crop the image. Click \"Crop\" when finished to add the image to your design. ")
], -1)
const _hoisted_6 = { class: "btns-wrap" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.fadeTransition, "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["modal-body", _ctx.bounceTransition]),
        ref: "modalBody"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", {
            style: {"height":"30px","width":"30px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModalAndCleanInput')))
          }, [
            _createVNode(_component_CloseSVG, { propId: 'crop-image-close' })
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("canvas", _hoisted_4, null, 512)
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            "aria-label": "Don't Crop",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.noCrop && _ctx.noCrop(...args))),
            id: "left-btn"
          }, " Don't Crop "),
          _createElementVNode("button", {
            "aria-label": "Crop Image",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cropImage && _ctx.cropImage(...args))),
            id: "right-btn"
          }, " Crop ")
        ])
      ], 2)
    ], 2)
  ]))
}